import React from 'react';
import PatientChatbot from './PatientChatbot';

export default function DrWathiqBookingPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col font-sans" dir="rtl">
      {/* Hero Section */}
      <div className="w-full bg-white shadow-sm border-b border-slate-200 py-8 px-4 text-center flex flex-col items-center justify-center shrink-0">
        <h1 className="text-3xl md:text-4xl font-extrabold text-slate-800 mb-3 drop-shadow-sm">
          الدكتور واثق عبدالخالق الجلبي
        </h1>
        <p className="text-lg md:text-xl text-indigo-700 font-bold mb-3">
          طبيب ممارس - امراض جلدية
        </p>
        <div className="bg-indigo-50 border border-indigo-200 text-indigo-800 px-4 py-1.5 rounded-full text-sm font-bold shadow-sm inline-flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
          رقم التسجيل: 17582
        </div>
      </div>

      {/* Main Content Area - Alaa Chatbot */}
      <div className="flex-1 w-full max-w-6xl mx-auto p-4 md:p-8 flex flex-col h-full">
        <div className="bg-white rounded-3xl shadow-2xl border border-slate-200 flex-1 overflow-hidden relative min-h-[600px]">
          <PatientChatbot isOpen={true} />
        </div>
      </div>
      
      {/* Footer */}
      <footer className="w-full text-center py-4 text-slate-500 text-sm bg-white border-t border-slate-200 shrink-0">
        © 2026 عيادة الدكتور واثق عبدالخالق الجلبي - جميع الحقوق محفوظة
      </footer>
    </div>
  );
}
